import { useEffect } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CommessaDataModal } from '@/pages/commesse/form/commessa-data-modal';
import { usePermissions } from '@/hooks/use-permissions';
import { PROTECTED, COMMESSE } from '@/lib/constants/routes';

const RETURN_URL = `${PROTECTED}${COMMESSE}`;

export const Route = createFileRoute('/protected/_layout/commesse/_layout/new')(
  {
    component: NewCommessaModal,
  }
);

/**
 * "Nuova commessa" apre il CommessaDataModal SOPRA la lista (il layout
 * parent renderizza `<Commesse />` + `<Outlet />`), come il
 * DocumentCreationDialog delle fatture. Alla creazione si naviga nello
 * sheet di dettaglio con `replace`, così il Back del browser torna alla
 * lista e non riapre il modal.
 */
function NewCommessaModal() {
  const navigate = useNavigate();
  const { canWrite, isLoading } = usePermissions();

  const close = () => navigate({ to: RETURN_URL, search: (old) => old });

  // Guard deeplink: senza permesso di scrittura si rimbalza alla lista.
  useEffect(() => {
    if (!isLoading && !canWrite) {
      navigate({ to: RETURN_URL, search: (old) => old });
    }
  }, [isLoading, canWrite, navigate]);

  if (isLoading || !canWrite) return null;

  return (
    <CommessaDataModal
      open
      onOpenChange={(open) => {
        if (!open) close();
      }}
      onCreated={(commessa) =>
        navigate({
          to: `${RETURN_URL}/${commessa.id}`,
          search: (old) => old,
          replace: true,
        })
      }
    />
  );
}
